import React, { useState } from 'react'
import { setChat, setTaskList } from '../../redux/slices/AiAssistant';
import { EditIcon2, Trash } from '../LandingHeader/Feedback/icons/Icons';
import DeletedChat from './DeletedChat';
import moment from 'moment';
import EditChatTitle from './EditChatTitle';
import { useDispatch } from 'react-redux';
import ActionsDropdown from '../common/ActionsDropdown';
import { getTaskList } from '../action/chatGPT';

const HistoryItem = ({c, id, theme, deleteChat, disappearChat, undoChat}) => {
    const content = JSON.parse(c.conversation);
    const [editChatTitleId, setEditChatTitleId] = useState(null);
    const dispatch = useDispatch();

    const chatContent = (c, data) => {
        return c?.title ?? (data?.[data.length - 1].content ?? '');
    }

    const chatPersona = (data) => {
        return data?.[data.length - 1].sender ?? 'Default';
    }

    const changeConversation = (e, c) => {
        e.preventDefault();
        if(!e.target.closest('.actions-dropdown-container') && c.deletedAt === null && c.id != editChatTitleId){
            dispatch(setChat({data: JSON.parse(c.conversation), title: c.title, id: c.id, taskList: c.taskList ? c.taskList : {}, changed: true}));
            document.querySelector('.chatTextarea').focus();
            getTaskList(c.id).then(res => {
                if(res?.data?.responseData){
                    dispatch(setTaskList(res?.data?.responseData));
                }
            })
        }
    }

    const editChatTitle = (e, id) => {
        e.preventDefault();

        setEditChatTitleId(id);
    }

    const hideEditChatTitle = (c) => {
        setEditChatTitleId(null);
        dispatch(setChat({data: JSON.parse(c.conversation), title: c.title, id: c.id, taskList: c.taskList ? c.taskList : {}}));
    } 

    return (
        <li key={c.id} className={`li-menus ${c.deletedAt === null ? '' : 'deleted-task'} ${editChatTitleId !== null && c.id == editChatTitleId ? 'editing' : ''}`} onClick={e => changeConversation(e, c)}>
            {
                c.deletedAt !== null
                ?
                <DeletedChat trigger={disappearChat} undoChat={undoChat} c={c} />
                :
                (
                    editChatTitleId !== null && c.id == editChatTitleId
                    ?
                    <EditChatTitle theme={theme} trigger={hideEditChatTitle} cancelAction={setEditChatTitleId} c={c} />
                    :
                    <a href="#" className={`${c.id == id ? 'active' : ''}`}>
                        <span className={`histry-title-name ${c.id == id ? 'darkPrimaryColor' : ''}`}>{chatContent(c, content)}</span>
                        <span className='date !text-sm !font-normal !opacity-50'>{moment(c.createdAt).fromNow()}</span>
                        <ActionsDropdown actions={[{
                            icon: <EditIcon2 />,
                            title: 'Rename Chat',
                            action: (e) => editChatTitle(e, c.id)
                        },{
                            icon: <Trash />,
                            title: 'Delete Chat',
                            action: (e) => deleteChat(e, c.id)
                        }]} />
                    </a>
                )
            }
        </li>
    )
}

export default HistoryItem